import React from "react";
import { useWatch, useFormContext } from "react-hook-form";

import Editor from "@monaco-editor/react";
import { isEqual } from "lodash";

const JsonEditor = ({ source }) => {
    const value = useWatch({ name: source });
    const { setValue } = useFormContext();

    return (
        <Editor
            height="50vh"
            value={JSON.stringify(value || {}, null, 2)}
            defaultLanguage="json"
            onChange={(stringifiedValue) => {
                try {
                    const newValue = JSON.parse(stringifiedValue);

                    if (isEqual(newValue, value)) return;

                    setValue(source, newValue, { shouldDirty: true });
                } catch (e) {
                    // just ignore the error, the monaco editor should be already showing the error to the user
                    // NO-OP
                    console.error(e);
                }
            }}
        />
    );
};

export default JsonEditor;
